/**
 This directive is used in tables to make them navigatable with
 keyboard arrow keys
*/

import Vue from "vue";

export default {
  inserted: function(el, binding, vnode) {
    // TODO (example https://jsfiddle.net/bsacheri/gsh7nw5f/7/)
  }
};
